/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyClassificationWithSubClassifications {
    getFixupPrototypeFunction() { return PolicyClassificationWithSubClassifications.fixupPrototype; }

    static newInstance(model: Partial<PolicyClassificationWithSubClassifications>): PolicyClassificationWithSubClassifications {
        let obj = Object.assign(new PolicyClassificationWithSubClassifications(), model);
        PolicyClassificationWithSubClassifications.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyClassificationWithSubClassifications>): PolicyClassificationWithSubClassifications {
        if (!model) return null;
        return PolicyClassificationWithSubClassifications.newInstance(<PolicyClassificationWithSubClassifications> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyClassificationWithSubClassifications) {
        if (!obj) return;

        models.PolicyClassificationWithSubClassifications.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyClassificationWithSubClassifications): boolean {
        Object.setPrototypeOf(obj, PolicyClassificationWithSubClassifications.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * List of Access sub-classifications
     */
    access: Array<models.PolicyAccessSubClassification>;

    /**
     * List of Cost sub-classifications
     */
    cost: Array<models.PolicyCostSubClassification>;

    /**
     * List of Data sub-classifications
     */
    data: Array<models.PolicyDataSubClassification>;

    /**
     * List of Network sub-classifications
     */
    network: Array<models.PolicyNetworkSubClassification>;

    /**
     * List of Operation sub-classifications
     */
    operation: Array<models.PolicyOperationSubClassification>;

    /**
     * List of performance sub-classifications
     */
    performance: Array<models.PolicyPerformanceSubClassification>;

    /**
     * List of Resource sub-classifications
     */
    resource: Array<models.PolicyResourceSubClassification>;

    /**
     * List of security sub classifications
     */
    security: Array<models.PolicySecuritySubClassification>;

}
